import { produce } from 'immer'
import {
  AUTO_MATCH_RECEIPTS_ENABLED_SUCCESS,
  AUTO_MATCH_RECEIPTS_FAILURE,
  AUTO_MATCH_RECEIPTS_INIT,
  AUTO_MATCH_RECEIPTS_RESET,
  AUTO_MATCH_RECEIPTS_SUCCESS,
  AutoMatchReceiptsActions,
  AutoMatchReceiptsEnabledActions,
  COMPLETE_RECEIPTS_AUTO_MATCH_BULK_UPLOAD,
  CompleteReceiptsAutoMatchBulkUploadAction,
  SET_IS_CREATING_EXPENSES,
  SET_RECEIPT_AUTO_MATCH_ATTACHMENT_IDS,
  SetIsCreatingExpensesAction,
  SetReceiptAutoMatchAttachmentIdsAction,
} from 'src/app/UploadReceiptsAutoMatchPopup/redux/uploadReceiptsAutoMatch.actions'
import {
  SET_IS_UPLOAD_RECEIPTS_AUTO_MATCH_POPUP_OPEN,
  SetIsUploadReceiptsAutoMatchPopupOpenAction,
} from 'src/redux/actions/app.actions'
import {
  UPLOAD_ATTACHMENT_FAILURE,
  UPLOAD_ATTACHMENT_INIT,
  UPLOAD_ATTACHMENT_SUCCESS,
  UploadAttachmentActions,
} from 'src/redux/actions/data/receiptAttachments.actions'

export enum ReceiptAutoMatchPushTaskStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface ReceiptAutoMatchPushTaskListResponse {
  id: string
  receiptAttachmentId: string
  status: ReceiptAutoMatchPushTaskStatus
  transactionId?: string
  attachmentsCount?: number
}

export type BulkResponse = {
  bulkReceiptsAutoMatchId: string
  tasks: ReceiptAutoMatchPushTaskListResponse[]
}

export interface ReceiptsAutoMatchState {
  receiptAttachmentIds: string[]
  uploadingAttachmentThumbnails: Record<string, string>
  receiptAutoMatchPushTaskList: ReceiptAutoMatchPushTaskListResponse[]
  bulkReceiptsAutoMatchId?: string
  enabled: boolean
  receiptsAutoMatchError?: string
  isCreatingExpenses?: boolean
}

export const initialState: ReceiptsAutoMatchState = {
  receiptAttachmentIds: [],
  uploadingAttachmentThumbnails: {},
  receiptAutoMatchPushTaskList: [],
  enabled: false,
  isCreatingExpenses: undefined,
}

export type Actions =
  | UploadAttachmentActions
  | SetReceiptAutoMatchAttachmentIdsAction
  | SetIsUploadReceiptsAutoMatchPopupOpenAction
  | AutoMatchReceiptsActions
  | AutoMatchReceiptsEnabledActions
  | CompleteReceiptsAutoMatchBulkUploadAction
  | SetIsCreatingExpensesAction

const CoreReceiptsAutoMatchReducer = (
  state = initialState,
  action: Actions,
): ReceiptsAutoMatchState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_RECEIPT_AUTO_MATCH_ATTACHMENT_IDS: {
        draft.receiptAttachmentIds = action.payload.ids
        return draft
      }

      case UPLOAD_ATTACHMENT_INIT: {
        draft.uploadingAttachmentThumbnails = {
          ...draft.uploadingAttachmentThumbnails,
          [action.payload.uploadId]: action.payload.thumbnailUrl,
        }
        return draft
      }

      case UPLOAD_ATTACHMENT_FAILURE: {
        draft.uploadingAttachmentThumbnails = Object.keys(
          draft.uploadingAttachmentThumbnails,
        )
          .filter((id) => id !== action.payload.uploadId)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: draft.uploadingAttachmentThumbnails[curr],
            }),
            {},
          )
        return draft
      }

      case UPLOAD_ATTACHMENT_SUCCESS: {
        draft.uploadingAttachmentThumbnails = Object.keys(
          draft.uploadingAttachmentThumbnails,
        )
          .filter((id) => id !== action.payload.uploadId)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: draft.uploadingAttachmentThumbnails[curr],
            }),
            {},
          )
        draft.receiptAttachmentIds = [
          ...draft.receiptAttachmentIds,
          action.payload.id,
        ]
        return draft
      }

      case SET_IS_UPLOAD_RECEIPTS_AUTO_MATCH_POPUP_OPEN: {
        draft.uploadingAttachmentThumbnails = {}
        draft.receiptAttachmentIds = []
        draft.receiptsAutoMatchError = undefined
        return draft
      }

      case AUTO_MATCH_RECEIPTS_RESET: {
        draft.receiptAttachmentIds = []
        draft.receiptsAutoMatchError = undefined
        draft.bulkReceiptsAutoMatchId = undefined
        draft.receiptAutoMatchPushTaskList = []
        draft.uploadingAttachmentThumbnails = {}
        return draft
      }

      case AUTO_MATCH_RECEIPTS_INIT: {
        draft.receiptsAutoMatchError = undefined
        return draft
      }

      case AUTO_MATCH_RECEIPTS_SUCCESS: {
        draft.bulkReceiptsAutoMatchId = action.payload.bulkReceiptsAutoMatchId
        draft.receiptAutoMatchPushTaskList = action.payload.tasks
        return draft
      }

      case AUTO_MATCH_RECEIPTS_FAILURE: {
        draft.receiptsAutoMatchError = action.payload.error
        return draft
      }

      case AUTO_MATCH_RECEIPTS_ENABLED_SUCCESS: {
        draft.enabled = action.payload.receiptCaptureEnabled
        return draft
      }

      case COMPLETE_RECEIPTS_AUTO_MATCH_BULK_UPLOAD: {
        draft.receiptAttachmentIds = []
        draft.bulkReceiptsAutoMatchId = undefined
        draft.receiptAutoMatchPushTaskList = []
        return draft
      }

      case SET_IS_CREATING_EXPENSES: {
        const typedAction = action as SetIsCreatingExpensesAction
        draft.isCreatingExpenses = typedAction.payload.isCreatingExpenses
        return draft
      }
    }
  })
}
export default CoreReceiptsAutoMatchReducer
